import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IPrincipalSellerAdd } from '../../../shared/models/PrincipalSellerAdd';
import { ValidationService } from '../../../shared/providers/validation.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { UserManagerService } from '../../../shared/providers/user-manager.service'
import { ToastService } from '../../../shared/providers/toast.service'
import { AuthenticationService } from '../../../shared/auth/authentication.service';

@Component({
  selector: 'app-seller-listings',
  templateUrl: './seller-listings.component.html',
  styleUrls: ['./seller-listings.component.css']
})
export class SellerListingsComponent implements OnInit {

  @Input() propertyId: number;
  modalRef: BsModalRef;
  AddPrincipalModal = {} as IPrincipalSellerAdd;
  SellerDetailsLst: IPrincipalSellerAdd[];
  isSubmit: boolean = false;
  deleteUserId: number;
  user: any;
  valid:boolean  = true;

  constructor(private modalService: BsModalService, public Validation: ValidationService, private loader: LoaderService, public authService: AuthenticationService,
    private _dashboardService: DashboardService, private _userManagerService: UserManagerService, private _toastService: ToastService, ) { }

  ngOnInit(): void {
    this.user = this.authService.user;
    this.AddPrincipalModal.LoggedInUserId = this.user.Id;
    this.AddPrincipalModal.PropertyId = this.propertyId;
    this.LoadSellerDetails()
  }

  openModal(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  SavePrincipalFromPropDashboard() {
    this.isSubmit = true;
    
    if (this.Validation.IsinValid(this.AddPrincipalModal.FirstName) ||
      this.Validation.IsinValid(this.AddPrincipalModal.LastName) ||
      this.Validation.IsinValid(this.AddPrincipalModal.EmailAddress)
    ) {
      this.valid = false;
    }
    else if (!this.Validation.isEmail(this.AddPrincipalModal.EmailAddress)) {
      this.valid = false;
    }
    if (this.valid) {
      if (!this.SellerDetailsLst.find(x => x.EmailAddress === this.AddPrincipalModal.EmailAddress)) {
        this.loader.display(true);
        this._dashboardService.SavePrincipalFromPropDashboard(this.AddPrincipalModal).subscribe(res => {
          if (res) {
            if (this.AddPrincipalModal.Status == 1) {
              this._toastService.addToast({ title: 'Success', msg: 'Seller have been added to this property.', timeout:5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            }
            else {
              this._toastService.addToast({ title: 'Success', msg: 'Seller have been Invited to the application.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            }
            this.LoadSellerDetails();
            this.clear();
          }
          else if (!res && (this.AddPrincipalModal.Status != 1 && this.AddPrincipalModal.Status != undefined)) {
            this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while saving the user details', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
            this.loader.display(false);
            this.clear();
          }


        })
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'This user is already a seller for this property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.loader.display(false);
        this.clear();
      }
    }
  }

  LoadSellerDetails() {
    this._dashboardService.GetSellerDetails(this.AddPrincipalModal.PropertyId).subscribe(res => {
      this.SellerDetailsLst = res;
    })
  }

  grantSellerDashboardAccess(userguid, event) {
    let status = event.target.checked;
    this._userManagerService.ChangeSellerDashboardAccess(userguid, status).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the seller dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the seller dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }

  openDeleteModal(template: TemplateRef<any>, classes: any, item: IPrincipalSellerAdd) {
    this.deleteUserId = item.Userid;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  deleteSeller() {
    this._dashboardService.deleteSellerFromPropDashboard(this.propertyId, this.deleteUserId).subscribe(res => {
      if (res) {
        this.LoadSellerDetails();
        this._toastService.addToast({ title: 'Success', msg: 'You have successfully Deleted the seller from this property', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while deleting the seller', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      this.modalRef.hide()
    });
  }

  clear() {
    this.isSubmit = false;
    this.loader.display(false);
    this.modalRef.hide();
    this.AddPrincipalModal.FirstName = null;
    this.AddPrincipalModal.LastName = null;
    this.AddPrincipalModal.EmailAddress = null;
    this.AddPrincipalModal.PhoneNumber = null;
    
  }

  onEmailAddressChange() {
    if (this.AddPrincipalModal.EmailAddress != '') {
      this._dashboardService.GetUserDetailsByEmailAddress(this.AddPrincipalModal).subscribe(res => {

        if (res.UserStatus == 101 || res.UserStatus == 6750 || res.UserStatus == 0) {
          if (res.UserRoleId == 2 || res.UserRoleId == 0 || res.UserRoleId == 13) {
            this.AddPrincipalModal.FirstName = res.FirstName;
            this.AddPrincipalModal.LastName = res.LastName;
            this.AddPrincipalModal.PhoneNumber = res.PhoneNumber == null ? '' : res.PhoneNumber;
            this.AddPrincipalModal.Userid = res.Userid;

            if (res.FirstName != null) {
              this._toastService.addToast({ title: 'Success', msg: 'A user have been identified with the same email address', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
              this.AddPrincipalModal.Status = 1;  //Existing user
            }
            else {
              this.AddPrincipalModal.Status = 2;  //New user
            }
          }
          else {
            this._toastService.addToast({ title: 'Error', msg: 'Same email id exist in the application in a different user role. Kindly contact the administrator', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
            this.AddPrincipalModal.FirstName = null;
            this.AddPrincipalModal.LastName = null;
            this.AddPrincipalModal.EmailAddress = null;
            this.AddPrincipalModal.PhoneNumber = '';
            this.loader.display(false);
          }
        }
        else {
          this._toastService.addToast({ title: 'Error', msg: 'This user exist in the system but not Active. Kindly contact the administrator', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.AddPrincipalModal.FirstName = null;
          this.AddPrincipalModal.LastName = null;
          this.AddPrincipalModal.EmailAddress = null;
          this.AddPrincipalModal.PhoneNumber = '';
          this.loader.display(false);
        }
        });

    }
  }
}
